@if (sortedVoteTypes.length) {
  <div>
    <div class="row">
      <h3 class="title col-4 col-sm-2 col-lg-1">
        {{ milestoneName === "Screening Committee" ? "Attendance" : "Votes" }}
      </h3>
      <ul class="tallies col-8">
        <li class="yes">
          <mat-icon>thumb_up</mat-icon
            ><span class="label">{{ getTally(true) }}</span>
          </li>
          <li class="no">
            <mat-icon>thumb_down</mat-icon
              ><span class="label">{{ getTally(false) }}</span>
            </li>
            <li class="undecided">
              <mat-icon>help_outline</mat-icon
                ><span class="label">{{ getTally(null) }}</span>
              </li>
            </ul>
          </div>
          <ul class="votes-list row align-top">
            @for (voteType of sortedVoteTypes; track voteType) {
              <li
                class="col-6 col-md-4 col-lg-2"
                >
                <committee-vote
                  [vote]="getVoteForType(voteType)"
                  [readOnly]="readOnly"
                  (voteChange)="handleVoteUpdated($event)"
                  [project_id]="projectId"
                  [milestone_id]="milestoneId"
                  [voteType]="voteType"
                ></committee-vote>
              </li>
            }
          </ul>
        </div>
      }
